import {
  AutocompleteMultiselection,
  YesObject
} from '@yes.technology/react-toolkit'
import { ComponentProps } from 'react'

type Option = ComponentProps<typeof AutocompleteMultiselection>['options'][0]

type MultiselectionRelationProps = {
  label: string
  statusClass: 'processing' | 'default'
  suggestions: YesObject[]
  selectedObjects: YesObject[]
  value: string
  options: Option[]
  selectedOptions: Option[]
  inputRef?: React.Ref<HTMLInputElement>
  informational?: boolean
  onChangeObjects: (objects: YesObject[]) => void
  onChangeValue: (value: string) => void
}

const MultiselectionRelation = ({
  inputRef,
  label,
  statusClass,
  options,
  selectedObjects,
  suggestions,
  value,
  selectedOptions,
  informational,
  onChangeObjects,
  onChangeValue
}: MultiselectionRelationProps) => {
  const handleSelect = (targetSelection: Option) => {
    const isOptionAlreadySelected = selectedObjects.find(
      ({ uuid }) => uuid === targetSelection.id
    )

    const targetSuggestionObject = suggestions.find(
      ({ uuid }) => uuid === targetSelection.id
    )
    const optionsAfterSelection = targetSuggestionObject
      ? [...selectedObjects, targetSuggestionObject]
      : selectedObjects
    const optionsAfterDeselection = selectedObjects.filter(
      ({ uuid }) => uuid !== targetSelection.id
    )

    const newSelectedOptions = isOptionAlreadySelected
      ? optionsAfterDeselection
      : optionsAfterSelection

    onChangeObjects(newSelectedOptions)
  }

  return (
    <AutocompleteMultiselection
      ref={inputRef}
      statusClass={statusClass}
      onSelect={handleSelect}
      onChange={onChangeValue}
      {...{ options, value, selectedOptions, informational, label }}
    />
  )
}

export default MultiselectionRelation
